import { FormHelperText, InputLabel, styled } from "@mui/material";
import ReactQuill, { Quill } from "react-quill";
import { ValidationErrors } from "../../../hooks";
import { displayErrorMessages, getErrorMessages } from "../input-functions";

type RichTextEditorProps = {
  label?: string;
  required?: boolean;
  errors?: ValidationErrors | string[];
  placeholder?: string;
  value?: string | undefined;
  onChange?: (value: string | undefined) => void;
  height?: string;
  hasColor?: boolean;
  hasAlign?: boolean;
  justStyle?: boolean;
};

// this styled component will make sure that the height only applies to individual component instead of all components
const CustomReactQuill = styled(ReactQuill)<RichTextEditorProps>(({ height }) => ({
  "& .ql-container": {
    height: height,
  },
}));

export const RichTextEditor = (props: RichTextEditorProps) => {
  const errorMsg = getErrorMessages(props.errors);
  const hasError = errorMsg.length > 0;
  const toolbar: any = [];
  if (props.justStyle) {
    toolbar.push(["bold", "italic"]);
  }
  else {
    toolbar.push([{ size: [] }]);
    toolbar.push(["bold", "italic", "underline", "strike"]);
    toolbar.push([{ list: "ordered" }, { list: "bullet" }]);
    toolbar.push(["link", "image"]);
  }
  if (props.hasAlign) {
    toolbar.push([{ align: [] }]);
  }
  if (props.hasColor) {
    toolbar.push([{ color: [] }]);
  }
  return (
    <>
      {props.label && (
        <InputLabel error={hasError} required={props.required} shrink={true}>
          {props.label}
        </InputLabel>
      )}
      <CustomReactQuill
        placeholder={props.placeholder}
        height={props.height ? props.height : "auto"}
        value={props.value}
        onChange={props.onChange}
        modules={{
          toolbar: toolbar,
          clipboard: {
            // toggle to add extra line breaks when pasting HTML:
            matchVisual: false,
          },
          imageResize: {
            parchment: Quill.import("parchment"),
            modules: ["Resize", "DisplaySize"],
          },
        }}
      />
      {hasError && <FormHelperText error>{displayErrorMessages(errorMsg)}</FormHelperText>}
    </>
  );
};
